const en = {
    aftersales:{
        "contactus":"Contact us for quick response",
        "workorder":"Work order list",
        "createjob":"Create a job",
        "submittinworkorder":"When submitting a work order, please include as much detailed information as possible, such as error screenshots, account information, etc., which are very important for us to deal with problems quickly.You can click on the lower right corner to contact customer service",
        "workordercontent":"Work order Content",
        "subscriptionaccount":"Subscription account",
        "problemtype":"Problem type",
        "tobeprocessed":"To be processed",
        "processed":"Processed",
        "revoked":"Revoked",
        "create":"Create",
        "workorderno":"Work order No",
        "product":"Product",
        "status":"Status",
        "type":"Type",
        "ticket":"Ticket",
        "createtime":"createTime",
        "reply":"reply",
        "operate":'operate',
        "onlinechat":"Online Chat",
        "resolveworkorder":"We will resolve the issue as soon as you submit the work order",
        "noworkorder":"No Work Order",
        "revoke":"Revoke",
        "content":"Content"
    },
    excode:{
        "redemptioncode":"Redemption Code",
        "pleaseredemptioncode":"Please enter the redemption code",
        "exchange":"exchange",
        "notused":"not used",
        "used":"Used",
        "expired":"Expired",
        "status":"Status",
        "exchangetime":"Exchange date",
        "createtime":"createTime",
        "selectactivityarea":"Please select the activity area",
        "optionaltraintickets":"Optional train tickets",
        "newpurchase":"New Purchase",
        "renew":"Renew"
    },
    header:{
        "personaldetails":"Personal Details"
    },
    footer:{
        "contactus":"contact us",
        "navigation":"Navigation",
        "home":"Home",
        "friends":"Friends",
        "subscribe":"Subscribe",
        "aftersales":"AfterSales",
        "help":"Help",
        "termsofuse":"Terms of Use",
        "refundpolicy":"Refund Policy",
        "privacypolicy":"Privacy Policy",
        "paymentmethod":"Payment method",
        "language":"Language",
        "map":"Map",
        "homescreen":"Home Screen",
        "setpreferences":"Set Your Preferences",
        "setlanguage":"Please set your language"
    },
    friends:{
        "promotioninfo":"Promotion information",
        "currentlevel":"current level",
        "content":"You can use exclusive promotional links and discount codes to share with others to earn commissions. The higher the level, the higher the commission share",
        "rolemembers":"The role of members",
        "promotionallinks":"Promotional Links",
        "discountcodes":"Discount Codes",
        "copy":"copy",
        "rebateratio":"The rebate ratio is",
        "discountratio":"Discount ratio",
        "lowestdiscountratio":"Lowest discount ratio",
        "walletsandpoints":"Wallets and Points",
        "applywithdrawal":"After you apply for withdrawal, we will review and make payment within 3 working days",
        "withdraw":"Withdraw",
        "record":"Record",
        "integral":"Integral",
        "pointsused":"Points can be used for lottery",
        "orderdetails":"Order Details",
        "orderamount":"Order amount",
        "earnings":"Earnings",
        "withdrawalsrecord":"Withdrawals record",
        "accounts":"Accounts",
        "accounttype":"Account type",
        "withdrawalamount":"Withdrawal Amount",
        "cancel":"Cancel",
        "submit":"Submit",

        "greaterthan":"Amount must be greater than 0!",
        "normal":"normal",
        "invalid":"invalid",
        "bankcard":"bank card",
        "promotionlink":"Promotion link",
        "discountcode":"Discount code",
        "waitingforapproval":"Waiting for approval",
        "waitingforpayment":"Waiting for payment",
        "notpass":"not pass",
        "paid":"Paid",

        "cashwithdrawalid":"Cash withdrawal ID",
        "accountsreceivable":"Accounts receivable",
        "amount":"Amount(USD)",
        "status":"status",
        "applicationtime":"Application time",
        "processingresults":"Processing results",

        "sku":"SKU",
        "orderid":"order ID",
        "useramount":"User Amount",
        "duration":"duration",
        "promotiontype":"promotion type",
        "createtime":"createTime",
        "eainings":"Eainings(USD)",

        "receivingaccount":"receiving account",
        "nowithdrawableamount":"No withdrawable amount",
        "copysuccessfully":"Copy successfully",
        "copyfailed":"Copy failed",
        "salesvolume":"Sales Volume",
        "nodata":"No data available at the moment"
    },
    home:{
        'notice':'Click getNfcode to get the solution to Netflix unable to log in',
        'join':'Join',
        'Renewal':'Renew',
        "texttitle":"Open your shared subscription at a lower price",
        "buynow":"Buy Now",
        "soldout":"Product sold out",
        "delivery":"Real time delivery",
        "after":"Real time delivery after payment without waiting",
        "certificate":"SSl certificate",
        "payments":"Payments are made in a secure environment with ssl security certificates",
        "onlinesupport":"24/7 online support",
        "privatecustomer":"24/7 online private customer service",
        "subscriber":"The right co subscriber",
        "subscriptions":"Share premium subscriptions at a lower price. Priority matching for cosubscribers from the same country/region",
        "moneyback":"money-back guarantee",
        "refund": "You have 1-20 days to apply for a refund Please read the refund policy for details",
        "parkingspace":"parking space",
        "gift":"gift",
        "screen":"Screen",
        "1screen":"1 screen",
        "maxnum":"screen",
        "month":"Month",
        "buytyp":"Buy Type",
        "subscription":"subscription",
		"newsubscription":"new subscription",
		
		"newbuy":"newbuy",
        "voucher":"Voucher",
        "discountcode":"Discount code",
        "use":"Use",
        "paymentmethod":"Payment method",
        "pleasechoose":"please choose",
        "billingdetails":"Billing Details",
        "payaddress":"Payment Address Information",
        "firstname":"First name",
        "lastname":"Last name",
        "emailaddress":"Email address",
        "phone":"Phone",
        "country":"Country / Region",
        "state":"state",
        "city":"Town / City",
        "address":"Street address",
        "housenumber":"House number and street name",
        "suiteunit":"Apartment, suite, unit, etc. (optional)",
        "zipcode":"ZIP Code",
        "submit":"Submit",
        "creditcard":"Credit Card",
        "cardnumber":"Card number",
        "expirydate":"Expiry date",
        "nameoncard":"Name on card",
        "savethiscard":"Save this card for future payments",
        "play":"Play",
        "emailerror":"Email ERROR",
        "payresluttitle":"Payment succeeded",
        "Pleaseconfirmsuk":"Please confirm the product information",
        "buytips":"All of our subscriptions are shared and sold as sub-accounts, please make sure you understand this before purchasing.",
        "pleaseenter":"please enter",
        "selectamonth":"Please select a month",
        "selectthenumber":"Please select the number of screens",
        "selectthepurchase":"Please select the purchase type",
        "selectthepayment":"Please select the payment method",
        "discountcodenotempty":"Discount code cannot be empty!",
        "detail1":
            // "<p>✅We are not affected by the policyn</p>\n" +


            "<p><i class=\"el-icon-check\"></i><span>5 people share 1 subscription</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>We will be selling slot exclusive subscriptions later</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>4K, HDR, Dolby</span></p>\n"+
            "<p><i class=\"el-icon-check\"></i><span>If affected, we will refund</span></p>",
        "detail2":"<p><i class=\"el-icon-check\"></i><span>Premium Plan</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>High fidelity sound</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Live Delivery</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Mobile, PC, Tab</span></p>\n" +
            "<div id=\"gtx-trans\" style=\"position: absolute; left: 110px; top: 77.3906px;\">\n" +
            "<div class=\"gtx-trans-icon\">&nbsp;</div>\n" +
            "</div>",
        "detail3":"<p><i class=\"el-icon-check\"></i> <span>Premium Plan</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>6 people share 1 subscription,</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Mobile, PC, TV</span> </p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Personal Profile and History</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Keep all favorites and lists</span></p>",
        "detail5":"<p ><i class=\"el-icon-check\"></i> <span>Premium Plan</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Send invitation link in real time</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>After the purchase is completed, please submit your email on the subscription page</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Personal subscription, keep all favorites and lists</span></p>\n" +
            // "<p>✅ Guarantee, Money Back Guarantee</p>\n" +
            // "<p>✅ Help: Before purchasing, check play.google.com if your account country is KR, ES, FR, PL, IT, DE, NL, GB, CA, US, JP, GR, CH, LT, PA, SG , CZ, SE, PT, BE, IL.</p>\n" +
            "<div id=\"gtx-trans\" style=\"position: absolute; left: -51px; top: 143.094px;\">\n" +
            "<div class=\"gtx-trans-icon\">&nbsp;</div>\n" +
            "</div>",
        "detail7":"<p><i class=\"el-icon-check\"></i> <span>Renew same subscription</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Keep all favorites and lists</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Live Delivery</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Before purchasing, please open the following link to see if max can be used https://www.max.com/</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Guarantee, Money Back Guarantee</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Share subscription. 1 screen view only (1/4) For more information</span></p>",
        "detail8":"<p><i class=\"el-icon-check\"></i> <span>ChatGPT Plus 4.0</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i>  <span>Enjoy GPTs</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Available For Plugins</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Ban API</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Chat record protection</span> </p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>4.0 model chat conditions are not limited.</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>After-sales support, 24hours worry-free refund</span></p>\n" ,
        "detail9":"<p><i class=\"el-icon-check\"></i> <span>4 people share 1 subscription</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Real-time delivery</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Support mobile terminal, PC, TV, TV box</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>4K, HDR, Dolby</span></p>",
        "detail10":"<p><i class=\"el-icon-check\"></i> <span>Premium plan</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Send invitation link in real time</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Private subscription, keep all</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Your favorites and lists</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Warranty, refunds guarantee</span></p>",
        "detail11":"<p><i class=\"el-icon-check\"></i> <span>Separate Account</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>An account that only one person can use</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Private subscription, keep all</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Not affected by Netflix policies</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>No code verification code will appear</span></p>",
        "detail12":"<p><i class=\"el-icon-check\"></i> <span>No ChatGPT Account Required</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Protected Chat Messages</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Support GPT-4o and GPT-4o-mini</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Support GPT-4.1, GPT-4.5, GPT-o3</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>High-performance servers guarantee your stable access</span></p>",
        "detail13":
            "<p><i class=\"el-icon-check\"></i><span>Education Plus Plan (excluding Notion AI)</p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Modular freedom: Eliminates tool-switching confusion</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Integrated workspace: 57% cost savings for tools</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Real-time collaboration: Zero-delay demand coordination</span></p>",
         "detail14":
            "<p><i class=\"el-icon-check\"></i><span>Enjoy Super Duolingo</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Members can enjoy an ad-free learning environment, avoiding distractions during each lesson and focusing on studying</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Use the ‘Customized Practice’ feature to correct errors during practice</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Members can challenge the highest legend level indefinitely, master the learned content in depth, and improve their language skills</span></p>",
        "lowerpricesharelarge":"Enjoy digital software subscriptions with an affordable price on",
        "lowerpricesharesmall":"Enjoy digital software subscriptions with an affordable price on <span class='green-text-2'>AlongShare</span>",
        "highqualitystreaming":"Providing high quality and low price for 3 consecutive years",
        "detail":"Detail",
        "moreactivities":"Lots of activities, lots of gains",
        "sharejoinsubscription":"<span class='green-text-2'>Share</span> Join the collaboration",
        "shareyoursubscription":"Share Alongshare with friends",
        "availabletime":"With exclusive discount code",
        "makemoney":"Someone else uses your discount code to buy",
        "widerangesubscription":"You can get corresponding order rebates",
        "threestepsshare":"You can view the promotion order details in the commission panel",
        "joinsubscription":"Join the collaboration",
        "saveupsubscriptionfees":"Publish promotional posts/videos on Naver/YouTube/Telegram by yourself",
        "securepayment":"Include your own discount code in the promotion",
        "manualreview":"After the promotion, you can easily check the order status on the \"추천 할인\" page",
        "oneclickjoin":"You can withdraw cash when your wallet accumulates $30",
        "whyusealongshare":"Why are<span class='green-text-2'> more and more</span> people using<span class='green-text-2'> Alongshare</span>",
        "position":"{0} Position",
        "selectdiscount":"Select Discount",
        "notstoreinfo":"AlongShare does not store your bank card information. All transactions are protected, processed, and authorized by external payment providers.",
        "alumpsum":"A Lump Sum",
        "details":"Details",
        "subtotal":"Subtotal",
        "promotioncodescoupons":"Promotion Codes&Coupons",
        "paymentfee":"Payment Fee",
        "total":"Total",
        "nowastediscount":"Don't waste this discount!",
        "hoursjoin":"Joined {hours} hours ago",
        "minutesjoin":"Joined {minutes} minutes ago"
    },
    login:{
        "welcomelogin":"Welcome to Login",
        "login":"Login",
        "updatepwd":"Change Password",
        "reg":"Registered Account",
        "agreement":"You signify that you have read and accept our terms and conditions Please read our Privacy Policy to find out how your data is processed",
        "quicklogin":"Quick Login",
        "sendcode":"Send Code",
        "register":"Register",
        "changepassword":"Change Password",
        "verificationcode":"Verification Code",

        "name":"Name",
        "password":"Password",
        "agapassword":"Repeat Password",
        "modify":"Modify",
        //"validatepswlen":"The password meets uppercase and lowercase letters, numbers and special characters, any combination of three of them, and the length is between 8 and 16!",
        "validatepswlen":"The password must contain any letters, numbers, or special characters",
        "checkagreement":"Please check the agreement",
        "passwordinconsistency":"The passwords entered twice are inconsistent!",
        "passwordagain":"please enter password again",
        "verificationsend":"The verification code has been sent, pay attention to check",
        "useemail":"Or use your email address",
        "agree":"Continuing means that you agree to our",
        "and":"and",
        "andconfirm":"and confirm",
        "readour":"You have read our",
        "forgotpassword":"Forgot Password",
        "codelogin":"Login with verification code",
        "verifyemail":"Verify Email",
        "sendcodeemail":"We will send the verification code via email to the input verification completed registration {email}.",
        "continue":"continue",
        "resend":"Resend",
        "noreceivecode":"Can't receive the verification code?",
        "passwordlogin":"Password login",
        "setpassword":"Set Password",
        "confirmpassword":"Confirm Password",

    },
    luckdraw:{
        "lotteryticket":"Lottery ticket",
        "integral":"integral",
        "welcome":"Welcome to alongshare, this is our activity page, click on the card to draw prizes with one click,\n" +
            "                                    the awards include various free account packages,\n" +
            "                                    discount codes and other discounts, thank you for your support and trust.",
        "none":"doesn't exist",
        "redemptioncode":"redemption code",
        "copy":"copy",
        "prizelist":"Prize list",
        "notused":"not used",
        "used":"Used",
        "expired":"Expired",

        "prizeno":"Prize No",
        "contents":"Contents",
        "exchangedate":"Exchange date",
        "createtime":"createTime",
        "exchange":"exchange",
        "insufficientpoints":"Insufficient points",
        "consumepoints":"This operation will consume 10 points. Continue?",
        "tips":"Tips",
        "comfirm":"Comfirm",
        "cancel":"Cancel",
        "failtowin":"Fail to win a prize",
        "congratulations":"Congratulations on obtaining",
        "copysucceeded":"Copy succeeded!",
        "copyfailed":"Copy failed!",

    },
    subscribe:{
        "clickto":"Click to get link.",
        "Resend":"Have you already sent a new code back? Get it again",
        "getverificationlink":" Get login verification link",
        "getlinktips":"If you have not been asked to fill in the verification code,please ignorethis feature.",
        "renewnow":"Renew now",
        "subscription":"Renew the same subscription without changing",
        "independent":"4K+HDR HD, independent viewing record",
        "guarantee":"money-back guarantee",
        "timeleft":"Time left",
        "openingtime":"Account opening time",
        "endtime":"End Time",
        "account":"Account",
        "password":"Password",
        "profile":"Profile",
        "pleaseuse":"please use",
        "subaccount":"sub account",
        "myprofile":"My profile is misused by someone!",
        "renew":"Renew",
        "aftersales":"After sales",
        "paidquota":"Paid quota",
        "nextresetdate":"Next reset date",
        "submitYoutube":'click "join" Button  to join the family group. Or copy the link and open it in the browser with the account you want to join',
        "yourownsub":"1.Please use your own sub account according to the serial number",
        "delete":"2.Do not modify/delete other sub-accounts",
        "modifysubscription":"3.Do not modify subscription-related information",
        "reminder":"Reminder: If you encounter any problems, please contact customer service in time, buy a subscription at alongshare, enjoy VIP customer service, and do not need to change the number for renewal.",
        "subtime":"The subscription period has been suspended and will not expire. The fee will only be charged after the problem is resolved.",
        "subtimetips":"The timer will restart after the problem is resolved.",
        
        
        "youtubeloginemail":"Enter your YouTube login email. You must use your entered email address to join the family group.\n" +
            "                                                Otherwise, you will be kicked out of the family. If you need help, please contact customer service in the lower right corner.",
        "aftersalesservice":"after sales service",
        "support":"support page.",
        "submit":"submit",

        "buyit":"There are no subscriptions yet, please hurry to buy it",
        "paymentsucceeded":"Payment succeeded",
        "month":"Please select a month",
        "number":"Please select the number of screens",
        "purchase":"Please select the purchase type",
        "payment":"Please select the payment method",
        "name":"Please enter Name on card",
        "card":"Please enter Card number",
        "cvv":"Please enter CVV",
        "expirydate":"Please enter Expiry date",
        "processing":"Processing status has been submitted. Check the processing status on the work order.",
        "cannotempty":"Discount code cannot be empty!",
        "originalpassword":"The original password for this operation will no longer be used, whether to continue?",
        "passwordmeets":"The password meets uppercase and lowercase letters, numbers and special characters, any combination of three of them, and the length is between 8 and 16!",
        //套餐名字
        //nf
        "11screen":"1 profile (5 people Shared)(1/5 TV)",
        "21screen":"1 profile (4 people Shared)(1/4 TV)",
        "31screen":"1 profile (5 people Shared)(1/1 TV)",
        "41screen":"1 profile (5 people Shared)(No TV)",
        "51screen":"5 profiles (Private)",
        "61screen":"solo subscription",
        "71screen":"Recharge (with your own account)",
        //sp
        "12screen":"1 profile (5 people Shared)",
        "72screen":"Recharge (with your own account)",
        //dsn
        "13screen":"1 profile (7 people Shared)",
        "53screen":"Private",
        //ytb
        "15screen":"1 profile (5 people Shared)",
        "75screen":"Recharge (with your own account)",
        //max
        "17screen":"1 profile (4 people Shared)",
        //gpt
        "18screen":"token+6 people Shared account",
        "58screen":"Private",
        "78screen":"Recharge (with your own account)",
        //脆卷
        "19screen":"1 profile (4 people Shared)",
        //plmount
        "110screen":"1 profile (4 people Shared)",
        //notion
        "113screen":"1 profile",
        //duolingo
        "114screen":"1 profile (5 people Shared)",
        //team
        "115screen":"1 profile",
    },
    userinfo:{
        "signout":"Sign out",
        "nickname":"Nickname",
        "avatar":"Avatar",
        "uploadavatar":"Please upload your avatar",
        "logout":"Are you sure you want to log out?",
        "onlyjpgpng":"Uploaded pictures can only be in JPG | png format",
        "cannotexceed":"The size of the uploaded image cannot exceed 5MB!",
        "exitalongshare":"Exit AlongShare?",
        "personaldata":"Personal Data",
        "clickimage":"Click on the image to edit",
        "edit":"Edit",
        "alongshareloginemail":"AlongShare Login Email",
        "save":"Save",
        "resetpassword":"Reset Password",
        "editpassword":"Edit Password",
        "passwordmust":"Your password must have",
        "anycharacter":"Any letter, number, special character",
        "twosamepasswords":"The two passwords you entered are the same",
        "currentpassword":"Current Password",
        "newpassword":"New Password",
        "confirmpassword":"Confirm password",
        "updatepassword":"Update Password"
    },
    wish:{
        "wish":"Wish",
        "help":"AlongShare will choose some wishes to help",
        "christmas":"them come true when Christmas comes, leave your wish",
        "submit":"Submit",
        "mywish":"my wish"
    },
    map:{
        "home":"Home",
        "userinfo":"User info",
        "login":"Login",
        "withfriends":"With friends",
        "subscribe":"Subscribe",
        "aftersales":"After Sales",
        "luckdraw":"Luckdraw",
        "wish":"Wish",
        "helpcenter":"Help Center",
        "tradingstamps":"trading stamps",
        "affiliateprogram":"Affiliate Program",
        "order":"Order"
    },
    order:{
        "whetherpayment":"Whether to make payment or not",
        "yes":"Yes",
        "no":"No"
    }
}

export default en
